export default __webpack_public_path__ + "static/media/FLOTA_MARINA_DASHBOARD_IMG.1a713fe1.png";